<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-kaia-logo="false"
    :show-lang-picker="false"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b_self_test_pain_average_question')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b_self_test_pain_average_description')"
        />
      </div>
      <ScoreSlider
        :label="getScoreSliderLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_pain_intensity_severe_pain')"
        :min-text="$t('b2b_self_test_pain_intensity_no_pain')"
        :score="getScoreSliderValue"
        data-qa="score-slider"
        @change="handleSliderChange"
        @tap="handleSliderChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'

const reevaluationsStore = useSelfTestReevaluationStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const painAverage = computed(() => reevaluationsStore.painAverage)

const isValid = computed(
  () => painAverage.value >= 0 && painAverage.value <= 10,
)

const getScoreSliderValue = computed(() =>
  painAverage.value === -1 ? 5 : painAverage.value,
)

const getScoreSliderLabel = computed(() =>
  painAverage.value === -1 ? '' : `${painAverage.value}`,
)

const handleSliderChange = ({ value }) => {
  reevaluationsStore.painAverage = value
}
</script>
